module.exports = __webpack_public_path__ + "img/gbwhatsapp-not-working-x1.a875843f.webp";